export const reset_password = {
  field: {
    email: 'E-Mail Address',
    password: 'Password',
    confirm_password: 'Confirm Password',
    code: 'Verification code from email'
  },
  button: { send_code: 'Send password reset code', reset: 'Reset password' },
  link: {
    to_auth_page: 'Return',
    success_change_link_to_auth_page: 'log in',
    send_repeated: 'Send code again'
  },
  error: {
    wrong_email: 'Wrong e-mail',
    wait_attempts_time_interval: 'Please try again in 30 seconds',
    wrong_password: 'Password does not meet requirements',
    email_code_not_found_or_has_expired: 'Code is not found or has expired',
    not_valid_password: 'Password is not valid',
    code_size: 'Code must be 6 characters',
    invalid_format: "The New password field is in the wrong format"
  },
  success_change_password: 'Password changed successfully, now you can',
  password_email_not_received: "Didn't receive an email code?",
  success_send_code:
    'An email with a code has been sent to your email {email}, please enter it in the field below to continue',
  generate_password: 'Generate password',
  password_requirements: 'Password Requirements',
  six_symbols: '6 characters',
  one_number: '1 number',
  one_uppercase_letter: '1 capital letter',
  one_lowercase_letter: '1 uppercase letter',
  one_special_character: '1 special character (!@#;%^&* etc)',
  password_spaces: 'Password without spaces',
  matched_passwords: 'Passwords match',
  change_by: {
    email: 'Change via email',
    password: 'Change via current password'
  },
  day_block: "Daily attempts limit has expired, use the last code sent or request a new one tomorrow",
  code_exist: 'Use the last code sent or request a new one',
  send_email_to_confirm: 'An email with a code will be sent to your {email}.',
  send: 'Send'
};
